import * as React from 'react';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { ListItem } from './ListItem';
import { ListItemText } from './ListItemText';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  icon: {
    fontSize: theme.spacing(4)
  }
});

type Props = WithStyles<typeof styles>;

const ErrorItemComponent: React.FC<Props> = ({ classes }) => (
  <ListItem>
    <ListItemText style={{ textAlign: 'center' }}>
      <ErrorOutlineIcon className={classes.icon} />
    </ListItemText>
  </ListItem>
);

export const ErrorItem = withStyles(styles)(ErrorItemComponent);
